module.exports = __webpack_public_path__ + "img/4_8.1481f504.png";